var ERROR_MESSAGES = {
  UserNotConfirmedException:
    "Twój adres email nie został zweryfikowany. Sprawdź pocztę i zweryfikuj adres, żeby się zalogować.",
  NotAuthorizedException: "Nieprawidłowy email lub hasło.",
  UserNotFoundException: "Nieprawidłowy email lub hasło.",
  UsernameExistsException:
    "Użytkownik z podanym adresem email już istnieje. Kliknij przycisk 'Mam już konto', aby się zalogować.",
  CodeMismatchException: "Nieprawidłowy kod, spróbuj jeszcze raz.",
  "Password did not conform with policy: Password not long enough":
    "Hasło jest za krótkie",
  "Invalid phone number format.": "Niewłaściwy format numeru telefonu.",
  "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length less than or equal to 256":
    "Hasło musi mieć długość mniejszą bądź równą 256.",
  "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6":
    "Hasło musi mieć długość większą bądź równą 8.",
  "Password did not conform with policy: Password must have lowercase characters":
    "Hasło musi zawierać małe litery.",
  "Password did not conform with policy: Password must have uppercase characters":
    "Hasło musi zawierać wielkie litery.",
  "Password did not conform with policy: Password must have numeric characters":
    "Hasło musi zawierać znaki numeryczne.",
  "Password did not conform with policy: Password must have symbol characters":
    "Hasło musi zawierać znaki specjalne.",
  "Member must satisfy regular expression pattern":
    "Hasło musi mieć długość większą bądź równą 8. Hasło musi zawierać znaki specjalne."
};

export function get_error_message(e) {
  var message = ERROR_MESSAGES[e.message];
  if (message) {
    return message;
  }
  message = ERROR_MESSAGES[e.code];
  if (message) {
    return message;
  }
  if (e.message.includes("Member must satisfy regular expression pattern")) {
    return ERROR_MESSAGES["Member must satisfy regular expression pattern"];
  }
  return e.message;
}
